import {
    Component,
    OnInit,
    ViewContainerRef,
    ViewChild,
    TemplateRef,
} from '@angular/core';
import { SiteServices } from '../../services/siteservices';

import { Router, Event as NavigationEvent } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { FileUploader } from 'ng2-file-upload';
import { Location } from '@angular/common';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ProviderContext } from '../../data/Entities';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalDialogService } from 'ngx-modal-dialog';
import { SimpleModalComponent } from 'ngx-modal-dialog';

declare var appConfig: any;

@Component({
    selector: 'categoryblock_detail',
    templateUrl: 'templates/get/CategoryBlock/categoryblock_detail',
})
export class CategoryBlockDetailFrm implements OnInit {
    PCODE: string = 'CATEGORYBLOCK';
    public submitted: boolean = false;
    public isupload: boolean = false;
    public isupload2: boolean = false;
    public isMobileImguploader: boolean = false;
    public errstr: string;
    public categoryBlockID: number;
    public providerList: any[];
    public categoryProviderList: any[];
    public productClasses: any[];
    public selectedProductClassIds: number[] = [];
    public brands: string[];
    public selectedBrands: string[] = [];
    public htmlMarketingElementNames: string[] = [];

    public entity: any = {
        CategoryBlockTypeID: '',
        BackColor: '#ffffff',
        TitleTextColor: '#000000',
        LayoutID: 0,
        Active: true,
    };
    public MediaServicesUrl: string;
    public categoryList: [] = [];
    public productList: [] = [];
    public searchText: string;
    public onlySelected: boolean = false;
    public uploader: FileUploader;
    public uploader2: FileUploader;
    public mobileImguploader: FileUploader;
    public modalRef: BsModalRef;

    @ViewChild('prodtemplate')
    private prodTemplateRef: TemplateRef<any>;

    @ViewChild('prodimporttemplate')
    private prodImportTemplate: TemplateRef<any>;
    
    public selectedProductIds: number[] = [];

    importProductText: string = '';
    importProductSelectedProviderId: number;
    
    constructor(
        public siteServices: SiteServices,
        private route: ActivatedRoute,
        private router: Router,
        private modalService: BsModalService,
        public modalService2: ModalDialogService,
        public location: Location,
        public viewRef: ViewContainerRef
    ) {
        this.MediaServicesUrl = appConfig.MediaServicesUrl;
        this.uploader = new FileUploader({
            url: 'interface/uploadimage/',
        });
        this.uploader2 = new FileUploader({
            url: 'interface/uploadimage/',
        });
        this.mobileImguploader = new FileUploader({
            url: 'interface/uploadimage/',
        });
    }

    refresh(id: any) {
        if (id && id != '0') {
            this.categoryBlockID = id;
            this.getProvidersForCategoryBlock(id);
            this.siteServices.provider_GetDataByID(
                this.PCODE,
                id,
                null,
                (data) => {
                    this.entity = data.TagObject;
                    if (
                        this.entity.CategoryID == null ||
                        !this.entity.CategoryID
                    )
                        this.entity.CategoryID = 0;
                    if (this.entity.CategoryID > 0) {
                        this.GetCategoryProducts(this.entity.CategoryID, id);
                    }
                    if (this.entity.OwnCategoryBrand) {
                        this.selectedBrands =
                            this.entity.OwnCategoryBrand.split('||');
                    }
                    if (this.entity.OwnCategoryProductClass) {
                        this.selectedProductClassIds = this.entity.OwnCategoryProductClass.map(({ ProductClassId }) => ProductClassId);
                    }
                }
            );
        }
    }

    /**
     * ****Betöltjük a categoryblokkhoz elérhető providereket
     * @param catid
     */
    getProvidersForCategoryBlock(catid: any) {
        this.providerList = [];
        this.siteServices.inProgress = true;
        if (catid) {
            this.siteServices.provider_Execute(
                this.PCODE,
                'GETPROVIDERSFORCATEGORYBLOCK',
                { CategoryID: catid },
                (data) => {
                    this.siteServices.inProgress = false;
                    this.providerList = data.TagObject;
                    this.categoryProviderList = this.providerList
                        .filter((x) => x.providerCategoryBlockRow)
                        .map((y) => ({
                            BlockCategoryID: catid,
                            ProviderID:
                                y.providerCategoryBlockRow.Provider.ProviderID,
                            ProviderName:
                                y.providerCategoryBlockRow.Provider
                                    .ProviderName,
                            AlternativeCategoryProviderID: y
                                .providerCategoryBlockRow
                                .AlternativeCategoryProvider
                                ? y.providerCategoryBlockRow
                                      .AlternativeCategoryProvider
                                      .AlternativeCategoryProviderID
                                : null,
                            AlternativeCategoryName: y.providerCategoryBlockRow
                                .AlternativeCategoryProvider
                                ? y.providerCategoryBlockRow
                                      .AlternativeCategoryProvider.CategoryName
                                : null,
                        }));
                    this.siteServices.provider_Execute(
                        this.PCODE,
                        'GETHTMLMARKETINGELEMENTSBYPROVIDER',
                        this.categoryProviderList.map(x => x.ProviderID),
                        (data) => {
                            this.htmlMarketingElementNames = data.TagObject;
                        }
                    );
                }
            );
        }
    }

    newBlock() {
        this.categoryProviderList.push({
            _edited: true,
            BlockCategoryID: this.categoryBlockID,
            ProviderID: 0,
            ProviderName: '',
            AlternativeCategoryProviderID: 0,
            AlternativeCategoryName: '',
        });
    }

    edit(blockCat) {
        blockCat._edited = true;
        this.onSelectProvider(blockCat.ProviderID, blockCat);
    }

    onSelectProvider(provid, blockCat) {
        if (blockCat._categoryList) return;

        this.siteServices.provider_Execute(
            this.PCODE,
            'GETALTERNATIVECATEGORYLIST',
            { ProviderID: provid },
            (data) => {
                blockCat._categoryList = data.TagObject;
            }
        );

        //console.log($event);
    }

    /**
     * ******Állítjuk az elérhető providerek állapotát
     * @param providerID
     */
    AddOrRemoveCategoryBlockProviders(blockCat, isAdd) {
        let _blockCat = Object.assign({}, blockCat);
        _blockCat.IsAdd = isAdd;
        delete _blockCat._categoryList;

        this.siteServices.provider_Execute(
            this.PCODE,
            'ADDORREMOVEPROVIDERSFORCATEGORYBLOCK',
            _blockCat,
            (data) => {
                this.getProvidersForCategoryBlock(this.categoryBlockID);
            }
        );
    }

    GetCategoryProducts(catid: any, catBlockId: any) {
        if (!catBlockId) catBlockId = this.categoryBlockID;
        this.productList = [];
        this.siteServices.inProgress = true;
        if (catid) {
            this.siteServices.provider_Execute(
                this.PCODE,
                'GETCATEGORYPRODUCTS',
                { CategoryID: catid, CategoryBlockID: catBlockId },
                (data) => {
                    this.siteServices.inProgress = false;
                    this.productList = data.TagObject;
                }
            );
        }
    }

    ngOnInit() {
        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETCATEGORYTREE',
            {},
            (data) => {
                //console.log(data);
                this.categoryList = data.TagObject;
                // this.productList = data.TagObject;
            }
        );

        this.siteServices.provider_Execute(
            this.PCODE,
            'GETPRODUCTCLASSESANDBRANDS',
            {},
            (data) => {
                console.log(data);
                this.productClasses = data.TagObject.ProductClasses;
                this.brands = data.TagObject.Brands;
            }
        );

        this.route.params.subscribe((params) => {
            if (params.id) {
                let id = params.id;
                if (id && id != '0') {
                    this.refresh(id);
                }
            }
        });

        this.uploader.onErrorItem = (item, response, status, headers) => {
            this.errstr = 'Hibás feltöltés (' + status + ')';
            this.isupload = false;
        };
        this.uploader.onSuccessItem = (item, response, status, headers) => {
            this.isupload = false;
            let r = JSON.parse(response);
            if (r.ErrStr) {
                this.errstr = r.ErrStr;
                this.siteServices.error(this.errstr);
                return;
            }
            this.entity.MediaGUID = r.Tag;
        };
        this.uploader.onBeforeUploadItem = (fileItem) => {
            this.errstr = '';
            this.isupload = true;
        };
        this.uploader.onAfterAddingFile = (fileItem) => {
            this.errstr = '';
            this.isupload = true;
        };
        this.uploader.options['autoUpload'] = true;

        this.uploader2.onErrorItem = (item, response, status, headers) => {
            this.errstr = 'Hibás feltöltés (' + status + ')';
            this.isupload2 = false;
        };
        this.uploader2.onSuccessItem = (item, response, status, headers) => {
            this.isupload2 = false;
            let r = JSON.parse(response);
            if (r.ErrStr) {
                this.errstr = r.ErrStr;
                this.siteServices.error(this.errstr);
                return;
            }
            this.entity.BackGUID = r.Tag;
        };
        this.uploader2.onBeforeUploadItem = (fileItem) => {
            this.errstr = '';
            this.isupload2 = true;
        };
        this.uploader2.onAfterAddingFile = (fileItem) => {
            this.errstr = '';
            this.isupload2 = true;
        };
        this.uploader2.options['autoUpload'] = true;


        this.mobileImguploader.onErrorItem = (item, response, status, headers) => {
            this.errstr = 'Hibás feltöltés (' + status + ')';
            this.isMobileImguploader = false;
        };
        this.mobileImguploader.onSuccessItem = (item, response, status, headers) => {
            this.isMobileImguploader = false;
            let parsedResponse = JSON.parse(response);
            if (parsedResponse.ErrStr) {
                this.errstr = parsedResponse.ErrStr;
                this.siteServices.error(this.errstr);
                return;
            }
            this.entity.MobileApplicationMediaGUID = parsedResponse.Tag;
        };
        this.mobileImguploader.onBeforeUploadItem = (fileItem) => {
            this.errstr = '';
            this.isMobileImguploader = true;
        };
        this.mobileImguploader.onAfterAddingFile = (fileItem) => {
            this.errstr = '';
            this.isMobileImguploader = true;
        };
        this.mobileImguploader.options['autoUpload'] = true;
    }

    save(frm) {
        this.submitted = true;
        if (!frm.valid) {
            this.siteServices.error('Hibás kitöltés!');
            return;
        }

        this.entity.OwnCategoryBrand =
            this.selectedBrands.length > 0
                ? this.selectedBrands.join('||')
                : null;

        this.entity.OwnCategoryProductClass = this.productClasses.filter(x => this.selectedProductClassIds.indexOf(x.ProductClassId) > -1)
        
        this.siteServices.provider_Save(this.PCODE, this.entity, (data) => {
            this.entity = data.TagObject;

            this.siteServices.onChangeDetail.next(this.entity);
            this.refresh(this.entity.CategoryBlockID);
            setTimeout((x) => this.siteServices.success('OK'), 200);
        });
    }

    addProd() {
        this.modalRef = this.modalService.show(this.prodTemplateRef, {
            class: 'modal-lg',
        });
    }

    importProd() {
        this.modalRef = this.modalService.show(this.prodImportTemplate, {
            class: 'modal-lg',
        });
    }

    selProd() {
        if (this.selectedProductIds.length < 1) {
            alert("Nem választottál terméket!")
            return;
        }
        
        this.siteServices.provider_Execute(
            this.PCODE,
            'UPDATEBUNDLE',
            {
                CategoryBlockID: this.entity.CategoryBlockID,
                ProductID: this.selectedProductIds,
            },
            (data) => {
                this.selectedProductIds = [];
                this.refresh(this.entity.CategoryBlockID);
                this.modalRef.hide();
            }
        );
    }

    delProd(prod: any) {
        this.siteServices.provider_Execute(
            this.PCODE,
            'DELBUNDLE',
            {
                CategoryBlockID: this.entity.CategoryBlockID,
                ProductID: prod.ProductID,
            },
            (data) => {
                this.refresh(this.entity.CategoryBlockID);
            }
        );
    }

    delete() {
        this.sure(this.viewRef, (x) => {
            this.siteServices.provider_Delete(
                this.PCODE,
                this.entity.CategoryBlockID,
                (x) => {
                    this.entity._deleted = true;
                    this.siteServices.onChangeDetail.next(this.entity);
                    this.siteServices.success('Törlés OK');
                    this.location.back();
                }
            );
        }); //sure
    }

    public sure(viewRef: ViewContainerRef, clbFunc: Function) {
        const actionButtons = [
            {
                text: 'igen',
                onAction: () => {
                    clbFunc();
                    return true;
                },
            },
            {
                text: 'nem',
                onAction: () => {
                    return true;
                },
            },
        ];

        this.modalService2.openDialog(viewRef, {
            title: 'Biztos vagy benne?',
            childComponent: SimpleModalComponent,
            actionButtons: actionButtons,
            data: { text: 'A termékblokkot visszavonhatatlanul töröljük' },
        });
    }

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(
            this.entity.CategoryBlockProduct,
            event.previousIndex,
            event.currentIndex
        );

        let arr = this.entity.CategoryBlockProduct.map((x) => x.ProductID);

        this.siteServices.provider_Execute(
            this.PCODE,
            'UPDATECATEGORYPRODUCTSPOSITION',
            {
                CategoryBlockID: this.entity.CategoryBlockID,
                ProductList: arr,
            },

            (data) => {}
        );
    }

    clearSelectedBrands() {
        this.selectedBrands = [];
    }
    
    clearSelectedProductClasses() {
        this.selectedProductClassIds = [];
    }

    clearSelectedHtmlMarketingElements() {
        this.entity.SelectedHtmlMarketingElements = [];
    }

    toggleSelection(productId: number): void {
        const index = this.selectedProductIds.indexOf(productId);
        if (index === -1) {
            this.selectedProductIds.push(productId);
        } else {
            this.selectedProductIds.splice(index, 1);
        }
    }

    isSelectedProduct(productId: number): boolean {
        return this.selectedProductIds.indexOf(productId) > -1;
    }
    
    importProducts(): void {
        if (this.importProductSelectedProviderId === undefined || this.importProductText === '') return;

        this.siteServices.provider_Execute(
            this.PCODE,
            'IMPORTPRODUCTS',
            {
                ProviderId: this.importProductSelectedProviderId,
                ProductList: this.importProductText,
                CategoryBlockId: this.categoryBlockID
            },
            () => {
                this.importProductSelectedProviderId = undefined;
                this.importProductText = '';
                this.refresh(this.categoryBlockID);
                this.modalRef.hide();
            }
        );
    }
}
